import { useFeatureValue } from '@growthbook/growthbook-react';
import { ArrowForward } from '@mui/icons-material';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { libraryUpdate } from '@/assets';
import { Button, NewFeatureBanner } from '@/components';
import { Routes } from '@/constants';
import {
  selectSessionUserId,
  selectUserProfileResult,
  useFetchUserUIStatesQuery,
  useUpdateUserUIStateMutation,
} from '@/store';

export const useIsLibraryUpdateVisible = () => {
  const userId = useSelector(selectSessionUserId);
  const { data: userProfile } = useSelector(selectUserProfileResult);
  const { data: userUIStates } = useFetchUserUIStatesQuery(undefined, {
    skip: !userId,
  });

  const cutoffDate = useFeatureValue(
    'library-announcement-cutoff-date',
    '1970-01-01',
  );
  const isUserCreatedBeforeUpdate =
    userProfile?.userCreatedAt &&
    new Date(userProfile.userCreatedAt) < new Date(cutoffDate);
  const isMdDown = useMediaQuery(theme => theme.breakpoints.down('md'));

  if (
    !userUIStates ||
    userUIStates?.isLibraryUpdateDismissed ||
    !isUserCreatedBeforeUpdate ||
    isMdDown
  ) {
    return false;
  }

  return true;
};

export const LibraryUpdate = () => {
  const [updateUserUIState] = useUpdateUserUIStateMutation();
  const navigate = useNavigate();

  return (
    <NewFeatureBanner
      onClose={() =>
        updateUserUIState({
          key: 'isLibraryUpdateDismissed',
          value: true,
        })
      }>
      <Box
        component="img"
        src={libraryUpdate}
        alt="library update"
        sx={{
          width: '100%',
          borderRadius: 2,
        }}
      />
      <Box>
        <Typography variant="body2SemiBold" color="primary.main" sx={{ my: 1 }}>
          Looking for Technical?
        </Typography>
        <Typography variant="caption1">
          Technical Search is now part of the Library. Use the new categories
          and filters to quickly find the most relevant episodes for your
          interests.
        </Typography>
      </Box>
      <Button
        variant="plain"
        label="Go to Library"
        endIcon={<ArrowForward />}
        fullWidth={false}
        sx={{ mt: 1.25 }}
        onClick={() => {
          navigate(Routes.LIBRARY);
          updateUserUIState({
            key: 'isLibraryUpdateDismissed',
            value: true,
          });
        }}
      />
    </NewFeatureBanner>
  );
};
